import {useDeploymentAccountGroupQuery} from './useDeploymentAccountGroupsQuery';

export const useDeploymentAccountGroup = (id?: string) => {
    const {data: record, isLoading: loading, refetch: fetchRecord} = useDeploymentAccountGroupQuery(id || '');

    return {
        record,
        loading,
        fetchRecord,
    };
};
